<template>
    <v-flex sm8 offset-sm2>
        <v-card  class="mx-1">
            <v-toolbar color="#AB377A" dense dark> 
                <v-toolbar-title>Registered Systems</v-toolbar-title>            
            </v-toolbar>
            <span>
                <v-list max-height="180" tile dense class="overflow-y-auto">
                    <v-list-item v-for="rs in $store.state.remoteSys" :key="rs.name" dense>
                        <v-list-item-content>
                            <remoteSys_StatCtrl v-bind="rs"></remoteSys_StatCtrl>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </span>
        </v-card>
        <br>

        <v-carousel v-model="$store.state.selectedOperation" :hide-delimiters="true" :show-arrows="true" :show-arrows-on-hover="true" height="auto">   
            <v-carousel-item >
                <v-card color="white" class="mx-1">
                    <v-toolbar color="#AB377A" dense>
                        <v-icon>mdi-shield-check-outline</v-icon>
                        <v-toolbar-title class="px-3">Check Integrity</v-toolbar-title>
                    </v-toolbar>
                    <v-img src="../assets/secCtrlCenter_triggerCheck.png" max-height="320px" class="ma-2 pa-2" contain></v-img>
                </v-card>
            </v-carousel-item>
            <v-carousel-item  >
                <v-card color="white" class="mx-1">
                    <v-toolbar color="#AB377A" dense>
                        <v-icon>mdi-restart-alert</v-icon>
                        <v-toolbar-title class="px-3">Force Reset</v-toolbar-title>
                    </v-toolbar>
                    <v-img src="../assets/secCtrlCenter_forceReset.png" max-height="320px" class="ma-2 pa-2" contain></v-img>
                </v-card>
            </v-carousel-item >
            <v-carousel-item >
                <v-card color="white" class="mx-1">
                    <v-toolbar color="#AB377A" dense>
                        <v-icon>mdi-arrow-decision-auto-outline</v-icon>
                        <v-toolbar-title class="px-3">Enable/Disable Auto-Policy</v-toolbar-title>
                    </v-toolbar>
                    <v-img src="../assets/secCtrlCenter_autoPolicy.png" max-height="320px" class="ma-2 pa-2" contain></v-img>
                </v-card>
            </v-carousel-item>
            <v-carousel-item  >
                <v-card color="white" class="mx-1">
                    <v-toolbar color="#AB377A" dense > 
                        <v-icon >mdi-information-outline</v-icon>
                        <v-toolbar-title class="px-3"> Get System Details </v-toolbar-title>                        
                    </v-toolbar>
                    <v-img src="../assets/secCtrlCenter_getInfo.png" max-height="320px" class="ma-2 pa-2" contain></v-img>
                </v-card>
            </v-carousel-item>
        </v-carousel>

        <br>
        
        <v-card >
            <v-toolbar color="#AB377A" dense dark> 
                <v-toolbar-title>System Log Messages</v-toolbar-title>            

                <v-spacer></v-spacer>
                
                <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" @click="$store.dispatch('clearLog')"><v-icon color="white">mdi-trash-can-outline</v-icon></v-btn>
                    </template>
                    Clear log
                </v-tooltip>
            </v-toolbar>

            <v-list max-height="180" tile dense class="overflow-y-auto">
                <v-list-item v-for="message in $store.state.messages" :key="message" dense>
                    <v-list-item-content>
                        <v-list-item-title v-text="message"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-flex>
</template>
<script>



import remoteSys_StatCtrl from './remoteSys_StatCtrl'

export default {
    components: {
        remoteSys_StatCtrl,
    },

    data() {
        return {
            remoteSys: [],
            messages: [],
            lastOperation: 3
        };
    },

    async created() {
        this.$store.dispatch('getLogMessages');
        this.$store.dispatch('getRemoteSystemList');
    },

    methods: {
    }
};
</script>